import moment from "moment";
import React from "react";
import _ from "lodash";
import { Button } from "reactstrap";

import { Link } from "react-router-dom";

const columns = (updateRole = false, columnActions = {}) => {
  const { onArchive, onUnarchive, canArchive } = columnActions;
  let returnArray = [
    {
      header: "Name",
      dataKey: "display_name",
      dataFilter: "text",
      sort: true,
    },
    {
      sort: true,
      header: "Site Installation QA",
      dataKey: "site_installation_qa",
      cellRenderer: (cell, row) => <div>{cell ? "Yes" : "No"}</div>,
      dataFilter: "select",
    },
    {
      sort: true,
      header: "Checklist Items",
      dataKey: "checklist_items_string",
      cellRenderer: (cell) => <div>{_.isNotEmpty(cell) ? cell : "None"}</div>,
    },
    {
      sort: true,
      header: "Site Installation QA Date",
      dataKey: "site_installation_qa_date",
      cellRenderer: (cell, row) => <div>{row.site_installation_qa ? moment(cell).format("DD/MM/YYYY") : "N/A"}</div>,
      dataFilter: "date",
    },
  ];

  returnArray.push({
    header: "Clone",
    dataKey: "edit",
    cellRenderer: (cell, row) => <Link to={`/project/${row.project_id}/areas/new?cloneID=${row.id}`}>Clone</Link>,
  });

  if (updateRole) {
    returnArray.push({
      header: "Edit",
      dataKey: "edit",
      cellRenderer: (cell, row) => <Link to={`/project/${row.project_id}/areas/${row.id}/edit`}>Edit</Link>,
    });
  }

  if (canArchive && onArchive && onUnarchive) {
    returnArray.push({
      header: "Archive",
      dataKey: "archived",
      cellRenderer: (cell, row) =>
        row.archived ? (
          <Button color="secondary" size="sm" onClick={() => onUnarchive(row)}>
            Unarchive
          </Button>
        ) : (
          <Button color="warning" size="sm" onClick={() => onArchive(row)}>
            Archive
          </Button>
        ),
    });
  }

  return returnArray;
};

export default columns;
